angular.module('impactx.opengovernmentdata').controller('SecondProcurementGroupListCtrl', ['selectedListItems', SecondProcurementGroupListCtrl]);

function SecondProcurementGroupListCtrl(selectedListItems) {

    var self = this;

    this.getDetailLink = function() {
        return "secondprocurementgroup/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinitions = [
        {label: "details", linkFunction: self.getDetailLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'SecondProcurementGroup'}
    ];

    this.meta = {
        rowTemplate: 'modules/opengovernmentdata/templates/secondprocurementgrouplist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/opengovernmentdata/secondprocurementgroup/list',
        ctrl: this,
        id: "secondprocurementgrouplist",
        excelExport: true,
        mainAction : {id:"new", link: "#/secondprocurementgroup/0", icon:"mdi-plus"},
        buttonDefinition: buttonDefinitions
    };

    this.getMeta = function() {
        return this.meta;
    };
}